"use client"
import Image from "next/image"
import dynamic from 'next/dynamic';
import {
  CheckCircleOutlined,
  TrophyOutlined,
  TeamOutlined,
  //   BriefcaseOutlined,
  BookOutlined,
  ClockCircleOutlined,
  GiftOutlined,
  ToolOutlined,
  BankOutlined,
  RightOutlined,
} from "@ant-design/icons"
const Faq = dynamic(() => import('@/components/faq'));
import { Button, Tabs, Collapse, Tag } from "antd"
import CourseCard from "@/components/offlineCourse/course-card"
import TestimonialCarousel from "@/components/offlineCourse/testimonial-carousel"
import { FaArrowRight, FaBriefcase } from "react-icons/fa6"
const Instructors = dynamic(() => import('@/components/instructors'));
import { faq, instructor, courses } from './faq'
import Link from "next/link";
import { useState } from "react";
import EnrollmentFormModal from "./enrollment-form-modal";
import BrochureDownloadModal from "./brochure-download-modal";
export default function OfflineCourses() {
  const { TabPane } = Tabs
  const { Panel } = Collapse
  // console.log('faq is ', faq)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleClose = () => {
    setIsModalOpen(false)
  }
  const [isBrowcherModalOpen, setIsBrowcherModalOpen] = useState(false)
  const showBrowcherModal = () => {
    setIsBrowcherModalOpen(true)
  }
  const handleBrowcherClose = () => {
    setIsBrowcherModalOpen(false)
  }
    const [activeKey, setActiveKey] = useState('digital-marketing');

const tabClass = (key: any) =>
  `px-6 py-2 rounded-md font-medium transition-all duration-300
   ${activeKey === key
     ? 'bg-orange text-white shadow-md'
     : 'bg-lightOrange text-orange hover:bg-orange-100'}`;
const scrollToCourses = () => {
  const courseSection = document.getElementById("courses");
  if (courseSection) {
    courseSection.scrollIntoView({ behavior: "smooth" ,block:"start" });
  }
};

  return (
    <div className="flex mt-16 flex-col min-h-screen">
      {/* Hero Section */}
      <div className=" px-4 mx-auto w-full lg:w-[95%] 2xl:w-[77%] overflow-hidden">
        <div className=" px-4 py-16 md:py-24 mx-auto">
          <div className="grid md:grid-cols-2 gap-8 ">
            <div className=" mx-auto ">
              <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-6">
                Transform Your Career with W3era Academy's Digital Marketing & Web Development Courses
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Join our expertly crafted courses to become a certified professional in Digital Marketing and Web
                Development. Hands-on experience, live projects, and 100% placement assistance await you.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button onClick={showModal}
                  className="bg-orange hover:bg-lightOrange py-2 hover:text-orange text-white text-lg font-medium  px-6 rounded-md flex items-center justify-center transition duration-200"
                >
                  Get Started Today
                  <RightOutlined className="ml-2 text-base" />
                </button>
                <EnrollmentFormModal isOpen={isModalOpen} onClose={handleClose} />
                <button onClick={scrollToCourses}
                  className="border-2 border-orange py-2 text-orange hover:bg-orange hover:text-white text-lg font-medium  px-6 rounded-md transition duration-200"
                >
                  Learn More About Our Courses
                </button>
              </div>
            </div>
            <div className="relative">
              <div className="relative z-10">
                <Image
                  src="/images/offline/student-digital-marketing.png"
                  alt="Digital Marketing Course"
                  width={600}
                  height={600}
                  className="rounded-lg shadow-xl"
                />
              </div>
              <div className="absolute top-4 right-4 bg-white p-3 rounded-lg shadow-lg flex items-center gap-2 z-20">
                <Tag color="orange" className="m-0 border-0 bg-orange-100 text-orange-600 px-2 py-1">
                  100% Placement
                </Tag>
              </div>
              <div className="absolute bottom-4 left-4 bg-white p-3 rounded-lg shadow-lg flex items-center gap-2 z-20">
                <Tag color="orange" className="m-0 border-0 bg-orange-100 text-orange-600 px-2 py-1">
                  Live Projects
                </Tag>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Why Choose Us Section */}
      <div className="py-16 px-4 mx-auto w-full lg:w-[95%] 2xl:w-[77%] bg-white">
        <div className=" px-4 mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-3xl font-bold mb-4">Why Choose W3era Academy?</h2>
            <p className="text-gray-600">
              At W3era Academy, we provide industry-leading Digital Marketing and Web Development courses designed to
              equip you with in-demand skills. With 100% placement support, hands-on live projects, and mentorship from
              industry experts, we ensure that our students are job-ready.
            </p>
          </div>
          <div className="flex  flex-wrap justify-center gap-6">
            {[
              {
                icon: "/images/offline/icons/icon1.svg",
                title: "100% Placement Assistance",
                description:
                  "Connect with top companies in digital marketing and web development, with a chance to work at W3era.",
              },
              {
                icon: "/images/offline/icons/icon2.svg",
                title: "Industry-Expert Trainers",
                description: "Learn from professionals with over 10 years of real-world experience.",
              },
              {
                icon: "/images/offline/icons/icon3.svg",
                title: "Hands-on Live Projects",
                description: "Gain practical experience by working on 1,500+ live projects to build your portfolio.",
              },
              {
                icon: "/images/offline/icons/icon4.svg",
                title: "Flexible Learning Options",
                description: "Choose from part-time, full-time, and weekend batches to fit your schedule.",
              },
              {
                icon: "/images/offline/icons/icon5.svg",
                title: "Lifetime Access",
                description:
                  "Get lifetime access to course materials and updates, keeping you ahead of industry trends.",
              },
              {
                icon: "/images/offline/icons/icon6.svg",
                title: "Scholarship Program",
                description: "Eligible candidates can receive a 100% fee waiver upon successful course completion.",
              },
              {
                icon: "/images/offline/icons/icon7.svg",
                title: "Free Access to W3era Tools",
                description: "Get lifetime access to our proprietary digital marketing tools to enhance your learning.",
              },
              {
                icon: "/images/offline/icons/icon8.svg",
                title: "500+ Students Trained",
                description: "Join over 500 successful graduates now working at top companies worldwide.",
              },
              {
                icon: "/images/offline/icons/icon9.svg",
                title: "50+ Industry Partnerships",
                description: "Real-time internships and job placements with leading companies in the industry.",
              },
            ].map((feature, index) => (
              <div className="flex flex-col py-4 px-6  w-full sm:w-[45%] lg:w-[32%] xl:w-[23.5%] bg-lightGrey gap-4 hover:bg-orange smooth1 group rounded-lg">
                <div className="bg-white p-3 w-fit rounded-full">

                <Image src={feature?.icon} width={40} height={40} alt="w3era academy" className="" />
                </div>
                {/* <span className="p-3 rounded-full bg-gray-400 text-white  w-[50px] h-[50px]">{feature.icon}</span> */}
                <p className="text-2xl text-black font-semibold group-hover:text-white">{feature.title}</p>
                <p className="text-sm text-black font-medium group-hover:text-white">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Instructors Section */}
      <div className="bg-[#F8F8F8]">
      <div className="pt-16   px-4 mx-auto w-full bg-g lg:w-[95%] 2xl:w-[77%] ">
        <div className=" px-4 mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-3xl font-bold mb-4">Meet Our Instructors</h2>
            <p className="text-gray-600">
              Learn from industry professionals with years of experience in Digital Marketing and Web Development.
            </p>
          </div>
        </div>
      </div>
      <Instructors instructor={instructor} />
      </div>
      {/* Courses Section */}
      <div className="py-16 px-4   mx-auto w-full lg:w-[95%] 2xl:w-[77%] bg-white" >
        <div className="  mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-3xl  font-bold mb-4" id="courses">Our Courses</h2>
            <p className="text-gray-600">
              Choose from our range of comprehensive courses designed to equip you with in-demand skills for today's job
              market.
            </p>
          </div>
          <div>
      <div className="flex justify-center gap-4 mb-8">
        <button
          className={tabClass('digital-marketing')}
          onClick={() => setActiveKey('digital-marketing')}
        >
          Digital Marketing
        </button>
        <button
          className={tabClass('web-development')}
          onClick={() => setActiveKey('web-development')}
        >
          Web Development
        </button>
      </div>

      {activeKey === 'digital-marketing' && (
        <div className="bg-orange-50 rounded-lg p-6 mb-8">
          <h3 className="text-2xl font-bold mb-4">Digital Marketing Course</h3>
          <p className="mb-4">
            Master the most essential skills in Digital Marketing. Whether you're looking to optimize websites for
            search engines or run paid ad campaigns, this course is designed to equip you with the knowledge and
            practical skills needed to excel.
          </p>
          <h4 className="text-xl font-semibold mb-2">Modules:</h4>
          <ul className="space-y-2 mb-6">
            {[
              "Digital Marketing Introduction: Overview of digital marketing, its importance, and the strategies that drive success.",
              "SEO (Search Engine Optimization): Learn how to optimize websites for higher search engine rankings.",
              "Google Ads: Master Google Ads to generate traffic and leads.",
              "Meta Ads (Facebook, Instagram): Learn how to run successful ad campaigns on social media platforms.",
              "Analytics & Reporting: Understand how to use Google Analytics to track and improve campaign performance.",
            ].map((module, index) => (
              <li key={index} className="flex items-start">
                <CheckCircleOutlined className="text-orange-600 mr-2 mt-1 flex-shrink-0" />
                <span>{module}</span>
              </li>
            ))}
          </ul>

          <div className="bg-white p-4 rounded-lg mb-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-500">Duration</p>
                <p className="font-medium">3-6 months</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Certification</p>
                <p className="font-medium">W3era Academy Digital Marketing Certification</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={showModal}
              className="bg-orange hover:bg-lightOrange hover:text-orange text-white font-medium rounded-md px-6 py-3 transition duration-300 shadow-md hover:shadow-lg"
            >
              Enroll Now
            </button>
            <EnrollmentFormModal isOpen={isModalOpen} onClose={handleClose} />
            <button
              onClick={showBrowcherModal}
              className="border border-orange text-orange hover:bg-lightOrange font-medium rounded-md px-6 py-3 transition duration-300"
            >
              Download Brochure
            </button>
            <BrochureDownloadModal isOpen={isBrowcherModalOpen} onClose={handleBrowcherClose} />
            <Link
              href="/offline-courses/digital-marketing-course"
              className="border border-orange text-orange hover:bg-lightOrange font-medium rounded-md px-6 py-3 transition duration-300 text-center"
            >
              Explore More
            </Link>
          </div>
        </div>
      )}

      {activeKey === 'web-development' && (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((course, index) => (
            <CourseCard
              key={index}
              title={course.title}
              subtitle={course.subtitle}
              description={course.description}
              duration={course.duration}
              imageSrc={course?.image}
            />
          ))}
        </div>
      )}
    </div>
        </div>
      </div>
      {/* Internship & Placement Section */}
      <div className="bg-orange">

        <div className="py-16 bg-gradient-to-r px-4 flex justify-between mx-auto w-full lg:w-[95%] 2xl:w-[77%]  text-white">
          <div className=" ">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h2 className="text-3xl font-bold mb-6">Internship, Placement & Scholarships</h2>
                <p className="mb-6">
                  Our focus is to ensure that our students gain both the skills and industry experience they need. With
                  100% placement assistance, real-time internship opportunities, and scholarships, we set our students up
                  for career success.
                </p>
                <ul className="space-y-4">
                  {[
                    "Internship Opportunities: Gain hands-on experience by working with leading companies in the digital marketing and web development industries.",
                    "Placement Assistance: We offer placement support to help you land a job upon course completion.",
                    "Scholarship Programs: We offer 100% scholarships to eligible students based on their performance and needs.",
                  ].map((item, index) => (
                    <li key={index} className="flex items-start">
                      <CheckCircleOutlined className="text-white mr-2 mt-1 flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="relative ">
                <Image
                  src="/images/offline/office-internship.png"
                  alt="Internship and Placement"
                  width={500}
                  height={500}
                  className="rounded-lg shadow-xl"
                />
                <div className="absolute -bottom-6 -left-6 bg-white text-gray-900 p-4 rounded-lg shadow-lg">
                  <div className="text-3xl font-bold text-orange-600">100%</div>
                  <div className="text-sm font-medium">Placement Assistance</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Testimonials Section */}
      <div className="">
        <div className="py-16 p-4  lg:w-[95%] xl:w-[75%]  mx-auto ">
          <div className="xl:container px-4 mx-auto">
            <div className="text-center max-w-3xl mx-auto mb-12">
              <h2 className="text-3xl font-bold mb-4">What Our Students Say</h2>
              <p className="text-gray-600">
                Hear from our students who have successfully completed our courses and transformed their careers.
              </p>
            </div>
          </div>
            <TestimonialCarousel />
        </div>
      </div>
      {/* FAQ Section */}
      <Faq faqs={faq} title="Frequently Asked Questions" description="Find answers to common questions about our courses, admissions, and more." />
      <section className="pt-12 border-t-[1px] border-orange  text-black">
        <div className="container px-4 mx-auto">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-4">Ready to Start Your Career with W3era Academy?</h2>
            <p className="mb-8">
              Enroll today in our Digital Marketing and Web Development courses to take the first step towards
              successful career. Our expert trainers and hands-on learning approach will help you achieve your
              professional goals.
            </p>
            <div className="flex justify-center">
              <button
                // size="large"
                onClick={showModal}
                className="bg-orange  hover:bg-lightOrange hover:text-orange text-white font-medium rounded-full px-8 h-12 transition duration-300 shadow hover:shadow-lg border-none flex items-center gap-2"
              >
                Enroll Now
                <FaArrowRight />
              </button>
              <EnrollmentFormModal isOpen={isModalOpen} onClose={handleClose} />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
